export const GET_PROFILE = 'GET_PROFILE'

export const updateProfileID = (profile) => {
  return {
    type: GET_PROFILE,
    payload: {
      profile
    }
  }
}
